import InventoryStructuredTableMode from 'notebook/integrations/samples/InventoryStructuredTableMode';
import {ParentStorableType} from 'samples/storables/StorableSchemaConstants';

export enum InventoryStructuredTableSchemaType {
  CONTAINER = 'container_schema',
  PLATE = 'plate_schema',
}

/**
 * Metadata needed for inventory structured tables.
 *
 * Agent keep in sync: benchling/notebook/structured_tables/constants/inventory_tables.py
 */
export interface InventoryTableMetadata {
  mode: InventoryStructuredTableMode.UPDATE_CONTAINERS;
  canChangeUnits: boolean;
  searchAllSchemas: boolean;
  storableSchemaType: InventoryStructuredTableSchemaType;
  fallbackRegistryId: string | null;
  parentStorableType: ParentStorableType;
  /** If true, rows are unlocked after submit and can be reused. Missing value is treated as falsey, which
   * has the default behavior of entirely freezing rows on submit. */
  unlockRowsAfterSubmit?: boolean;
}
